module.exports = __webpack_public_path__ + "static/media/arrow-to-top.fc6a4ed5.svg";